import React from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import ProductShowCard from '../Components/ProductShowCard';

const Catalog = () => {
     const { auth, data } = usePage().props;
     return (
          <React.Fragment>
               <Helmet>
                    <title>{data.product.name}</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">{data.product.name}</span>
               </div>
               <ProductShowCard />
               <div className="hidden sm:block">
                    <div className="py-8">
                         <div className="border-t border-gray-400"></div>
                    </div>
               </div>
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Catalog.layout = page => <UserLayout children={page} header={'Catalog'} />;

export default Catalog;
